import { Drip } from "./Drip";
import { BOOK_ALL } from "../data";

export const FinalCTA = () => (
  <section data-testid="final-cta" className="relative bg-barber-red">
    <Drip color="#0A0A0A" />
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 md:py-24 text-center">
      <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-wide text-white leading-[0.95]">
        READY FOR A<br />FRESH CUT?
      </h2>
      <p className="mt-5 text-base md:text-lg text-white/85 font-body">
        Wednesday to Saturday in Pakenham. Lock in your spot.
      </p>
      <a href={BOOK_ALL} data-testid="final-cta-book-btn"
        className="inline-flex mt-8 bg-black text-cream font-display text-lg tracking-wide px-10 py-4 rounded-md hover:bg-charcoal hover:scale-[1.03] transition-all duration-200">
        BOOK NOW →
      </a>
    </div>
  </section>
);
